import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var WD_EVENT_CATEGORY = 'WeeklyDashboard';
var WeeklyDashboardEvents = {
    pageView: WD_EVENT_CATEGORY + "_Open",
    datepickerClick: WD_EVENT_CATEGORY + "_Calendar_Open",
    activeStudentsHover: WD_EVENT_CATEGORY + "_ActiveStudents_Hover",
    onlineStudentsHover: WD_EVENT_CATEGORY + "_CurrentlyOnline_Hover",
    studentsActivityDiagramHover: WD_EVENT_CATEGORY + "_ActiveStudentsByDay_Hover",
    timeTargetCompletedHover: WD_EVENT_CATEGORY + "_TimeTargetCompleted_Hover",
    taskTargetCompletedHover: WD_EVENT_CATEGORY + "_TaskTargetCompleted_Hover",
    targetsDiagramHover: WD_EVENT_CATEGORY + "_TaskTargetCompletion_Hover",
    studentTimeTargetHover: WD_EVENT_CATEGORY + "_Student_TimeTarget_Hover",
    studentTaskTargetHover: WD_EVENT_CATEGORY + "_Student_TaskTarget_Hover",
    studentTasksCompletedHover: WD_EVENT_CATEGORY + "_Student_TaskCompleted_Hover",
    studentNameHover: WD_EVENT_CATEGORY + "_Student_Name_Hover",
    studentNextGradeReadinessHover: WD_EVENT_CATEGORY + "_Student_NGR_Hover",
    studentCurrentAreaOfFocusHover: WD_EVENT_CATEGORY + "_Student_CAF_Hover",
    studentRowExpand: WD_EVENT_CATEGORY + "_StudentMenu_Open",
    struggleStudentRowExpand: WD_EVENT_CATEGORY + "_StudentMenu_Struggle_Open",
    cardClick: WD_EVENT_CATEGORY + "_StudentMenu_OpenCard_NoStruggle",
    struggleCardClick: WD_EVENT_CATEGORY + "_StudentMenu_OpenCard_Struggle",
    struggleStudentLinkClick: WD_EVENT_CATEGORY + "_StudentName_Struggle_Click",
    studentLinkClick: WD_EVENT_CATEGORY + "_StudentName_Click",
    struggleStudentIconHover: WD_EVENT_CATEGORY + "_StudentName_StruggleIcon_Hover",
    studentCardIconHover: WD_EVENT_CATEGORY + "_StudentMenu_StruggleIcon_Hover",
    studentStruggleFilterEnable: WD_EVENT_CATEGORY + "_StudentMenu_FilterStuggle",
    stuckHelpIconHover: WD_EVENT_CATEGORY + "_Stuck_Tooltip_Hover",
    stuckTooltipLinkClick: WD_EVENT_CATEGORY + "_Stuck_Tooltip_Link_Click",
    stuckNameClick: WD_EVENT_CATEGORY + "_Stuck_Name_Click",
    stuckOpenCardClick: WD_EVENT_CATEGORY + "_Stuck_OpenCard",
    stuckTimeHover: WD_EVENT_CATEGORY + "_Stuck_Time_Hover",
    stuckShowAllClick: WD_EVENT_CATEGORY + "_Stuck_ShowAll_Click",
    stuckShowLessClick: WD_EVENT_CATEGORY + "_Stuck_Hide_Click",
};
var useWeeklyDashboardAnalytics = function () {
    return useFeatureGoogleAnalytics(WD_EVENT_CATEGORY);
};
export { useWeeklyDashboardAnalytics, WeeklyDashboardEvents };
